import { toDecimal, ZERO } from '@deltix/decimal-utils';
import { warn } from '@deltix/logger';
import { cloneDeepWith } from 'lodash';

var ESecurityType;
(function (ESecurityType) {
    ESecurityType["CRYPTO"] = "crypto";
    ESecurityType["FOREX"] = "forex";
    ESecurityType["STOCKS"] = "stocks";
    ESecurityType["FUTURE"] = "future";
    ESecurityType["OPTION"] = "option";
})(ESecurityType || (ESecurityType = {}));
var ETradingCommissionMethod;
(function (ETradingCommissionMethod) {
    ETradingCommissionMethod["EXACT_VALUE"] = "exact_value";
    ETradingCommissionMethod["TERM_TICKS"] = "term_ticks";
    ETradingCommissionMethod["QUANTITY_PERCENT"] = "quantity_percent";
})(ETradingCommissionMethod || (ETradingCommissionMethod = {}));
var ETradingCommissionAccount;
(function (ETradingCommissionAccount) {
    ETradingCommissionAccount["SOURCE_ACCOUNT"] = "source_account";
    ETradingCommissionAccount["DESTINATION_ACCOUNT"] = "destination_account";
    ETradingCommissionAccount["ABC_ACCOUNT"] = "abc_account";
})(ETradingCommissionAccount || (ETradingCommissionAccount = {}));
var ECurrencyType;
(function (ECurrencyType) {
    ECurrencyType["FIAT"] = "fiat";
    ECurrencyType["CRYPTO"] = "crypto";
    ECurrencyType["XXX"] = "xxx";
})(ECurrencyType || (ECurrencyType = {}));
var ETradingCurrency;
(function (ETradingCurrency) {
    ETradingCurrency["SIDE"] = "side";
    ETradingCurrency["BASE"] = "base";
    ETradingCurrency["TERM"] = "term";
})(ETradingCurrency || (ETradingCurrency = {}));
var EAccountStatus;
(function (EAccountStatus) {
    EAccountStatus["active"] = "active";
    EAccountStatus["suspended"] = "suspended";
})(EAccountStatus || (EAccountStatus = {}));
var Side;
(function (Side) {
    Side["buy"] = "buy";
    Side["sell"] = "sell";
})(Side || (Side = {}));
var EOrderType;
(function (EOrderType) {
    EOrderType["market"] = "market";
    EOrderType["stop"] = "stop";
    EOrderType["limit"] = "limit";
    EOrderType["stop_limit"] = "stop_limit";
    EOrderType["previously_quoted"] = "previously_quoted";
})(EOrderType || (EOrderType = {}));
var LinkedOrderType;
(function (LinkedOrderType) {
    LinkedOrderType["ouo"] = "ouo";
    LinkedOrderType["oso"] = "oso";
    LinkedOrderType["oso_ouo"] = "oso_ouo";
})(LinkedOrderType || (LinkedOrderType = {}));
var EOrderStatus;
(function (EOrderStatus) {
    EOrderStatus["new"] = "new";
    EOrderStatus["rejected"] = "rejected";
    EOrderStatus["canceled"] = "canceled";
    EOrderStatus["replaced"] = "replaced";
    EOrderStatus["partiallyFilled"] = "partially_filled";
    EOrderStatus["completelyFilled"] = "completely_filled";
    EOrderStatus["expired"] = "expired";
    EOrderStatus["pendingNew"] = "pending_new";
    EOrderStatus["pendingCancel"] = "pending_cancel";
    EOrderStatus["pendingReplace"] = "pending_replace";
    EOrderStatus["suspended"] = "suspended";
})(EOrderStatus || (EOrderStatus = {}));
var ETimeInForce;
(function (ETimeInForce) {
    ETimeInForce["ioc"] = "ioc";
    ETimeInForce["gtd"] = "gtd";
    ETimeInForce["gtc"] = "gtc";
    ETimeInForce["fok"] = "fok";
    ETimeInForce["day"] = "day";
})(ETimeInForce || (ETimeInForce = {}));
var EOrderEventType;
(function (EOrderEventType) {
    EOrderEventType["submitted"] = "submitted";
    EOrderEventType["reject"] = "reject";
    EOrderEventType["cancel"] = "cancel";
    EOrderEventType["cancelReject"] = "cancel_reject";
    EOrderEventType["replace"] = "replace";
    EOrderEventType["replaceReject"] = "replace_reject";
    EOrderEventType["trade"] = "trade";
    EOrderEventType["tradeCancel"] = "trade_cancel";
    EOrderEventType["tradeCorrect"] = "trade_correct";
})(EOrderEventType || (EOrderEventType = {}));
var EOperationStatus;
(function (EOperationStatus) {
    EOperationStatus["pending"] = "pending";
    EOperationStatus["approved"] = "approved";
    EOperationStatus["rejected"] = "rejected";
    EOperationStatus["inProgress"] = "in_progress";
    EOperationStatus["succeeded"] = "succeeded";
    EOperationStatus["failed"] = "failed";
})(EOperationStatus || (EOperationStatus = {}));
var ETransactionType;
(function (ETransactionType) {
    // Bank or credit card deposit.
    ETransactionType["deposit"] = "deposit";
    // Withdrawal of funds.
    ETransactionType["withdrawal"] = "withdrawal";
    ETransactionType["correction"] = "correction";
    // Profit or loss on trading.
    ETransactionType["execution"] = "execution";
    // Bonus or other credit.
    ETransactionType["credit"] = "credit";
    // Account debit.
    ETransactionType["debit"] = "debit";
    // Correction of balance.
    ETransactionType["balance_correction"] = "balance_correction";
    // Commission applied on withdrawal.
    ETransactionType["withdrawal_commission"] = "withdrawal_commission";
    // Commission applied on trading.
    ETransactionType["trading_commission"] = "trading_commission";
    // Commission applied on deal rollover.
    ETransactionType["rollover_commission"] = "rollover_commission";
    // Commission applied on deposit.
    ETransactionType["deposit_commission"] = "deposit_commission";
    // Price that was payed on binary option deal open.
    ETransactionType["binary_option_purchase"] = "binary_option_purchase";
    // Profit for binary option deal. Always either equal to invest or invest * (100 + payout) / 100.
    ETransactionType["binary_option_profit"] = "binary_option_profit";
    ETransactionType["interest"] = "interest";
    // Balance reservation for withdrawal.
    ETransactionType["withdrawal_reservation"] = "withdrawal_reservation";
    // Balance reservation cancel for withdrawal.
    ETransactionType["withdrawal_reservation_cancel"] = "withdrawal_reservation_cancel";
})(ETransactionType || (ETransactionType = {}));
var OrderViewType;
(function (OrderViewType) {
    OrderViewType["ORDERS"] = "ORDERS";
    OrderViewType["EVENTS"] = "EVENTS";
    OrderViewType["TRADING_POSITIONS"] = "TRADING_POSITIONS";
    OrderViewType["DEALINGS"] = "DEALINGS";
    OrderViewType["RATES"] = "RATES";
    OrderViewType["WIDGET"] = "WIDGET";
    OrderViewType["CLOSED_ORDERS"] = "CLOSED_ORDERS";
    OrderViewType["POSITIONS"] = "POSITIONS";
    OrderViewType["AUCTION_HISTORY"] = "AUCTION_HISTORY";
    OrderViewType["COMMISSIONS"] = "COMMISSIONS";
    OrderViewType["TV"] = "TV";
})(OrderViewType || (OrderViewType = {}));
var DockPosition;
(function (DockPosition) {
    DockPosition["FLOATING"] = "FLOATING";
    DockPosition["LEFT_TOP"] = "LEFT_TOP";
    DockPosition["LEFT_BOTTOM"] = "LEFT_BOTTOM";
    DockPosition["RIGHT_TOP"] = "RIGHT_TOP";
    DockPosition["RIGHT_BOTTOM"] = "RIGHT_BOTTOM";
    /** @deprecated */
    DockPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    /** @deprecated */
    DockPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(DockPosition || (DockPosition = {}));
var EOrderViewPosition;
(function (EOrderViewPosition) {
    EOrderViewPosition["Right"] = "right";
    EOrderViewPosition["Left"] = "left";
    EOrderViewPosition["Bottom"] = "bottom";
})(EOrderViewPosition || (EOrderViewPosition = {}));
var EChangeSide;
(function (EChangeSide) {
    EChangeSide["NONE"] = "none";
    EChangeSide["INC"] = "inc";
    EChangeSide["DEC"] = "dec";
})(EChangeSide || (EChangeSide = {}));
var EDisplayMethod;
(function (EDisplayMethod) {
    EDisplayMethod["PLAIN_TEXT"] = "plain_text";
    EDisplayMethod["FRACTIONS"] = "fractions";
    EDisplayMethod["PIPS_HIGHLIGHT"] = "pips_highlight";
})(EDisplayMethod || (EDisplayMethod = {}));
var EBarType;
(function (EBarType) {
    EBarType["MINUTE"] = "minute";
    EBarType["MINUTE5"] = "minute5";
    EBarType["MINUTE15"] = "minute15";
    EBarType["MINUTE30"] = "minute30";
    EBarType["HOUR"] = "hour";
    EBarType["HOUR4"] = "hour4";
    EBarType["HOUR8"] = "hour8";
    EBarType["DAY"] = "day";
    EBarType["WEEK"] = "week";
    EBarType["MONTH"] = "month";
})(EBarType || (EBarType = {}));
var ExecutionExplanation;
(function (ExecutionExplanation) {
    ExecutionExplanation["NONE"] = "none";
    ExecutionExplanation["PRICE"] = "price";
    ExecutionExplanation["COMMISSION"] = "commission";
})(ExecutionExplanation || (ExecutionExplanation = {}));
var SecurityType;
(function (SecurityType) {
    SecurityType["unknown"] = "unknown";
    SecurityType["currency"] = "currency";
    SecurityType["equity"] = "equity";
    SecurityType["futures"] = "futures";
    SecurityType["etf"] = "etf";
    SecurityType["cfd"] = "cfd";
    SecurityType["nft"] = "nft";
})(SecurityType || (SecurityType = {}));
var ETheme;
(function (ETheme) {
    ETheme["dark"] = "dark";
    ETheme["light"] = "light";
})(ETheme || (ETheme = {}));
var ChargeFlatCommissionTime;
(function (ChargeFlatCommissionTime) {
    ChargeFlatCommissionTime["ACKNOWLEDGMENT"] = "acknowledgment";
    ChargeFlatCommissionTime["FIRST_FILL"] = "first_fill";
})(ChargeFlatCommissionTime || (ChargeFlatCommissionTime = {}));
var OrderTable;
(function (OrderTable) {
    OrderTable["OpenOrders"] = "open_orders";
    OrderTable["ClosedOrders"] = "closed_orders";
    OrderTable["Events"] = "events";
})(OrderTable || (OrderTable = {}));
var PriceTypingType;
(function (PriceTypingType) {
    PriceTypingType["BEST_BID"] = "BEST_BID";
    PriceTypingType["BEST_ASK"] = "BEST_ASK";
    PriceTypingType["MID"] = "MID";
    PriceTypingType["MANUAL"] = "MANUAL";
})(PriceTypingType || (PriceTypingType = {}));
var SubmitOrderSource;
(function (SubmitOrderSource) {
    SubmitOrderSource[SubmitOrderSource["VISUALIZATION"] = 0] = "VISUALIZATION";
    SubmitOrderSource[SubmitOrderSource["FORM"] = 1] = "FORM";
    SubmitOrderSource[SubmitOrderSource["CLASSIC"] = 2] = "CLASSIC";
    SubmitOrderSource[SubmitOrderSource["INVEST_POSITION"] = 3] = "INVEST_POSITION";
    SubmitOrderSource[SubmitOrderSource["WIDGET"] = 4] = "WIDGET";
    SubmitOrderSource[SubmitOrderSource["DEALING"] = 5] = "DEALING";
    SubmitOrderSource[SubmitOrderSource["BASIC"] = 6] = "BASIC";
    SubmitOrderSource[SubmitOrderSource["RFQ"] = 7] = "RFQ";
    SubmitOrderSource[SubmitOrderSource["NFT"] = 8] = "NFT";
})(SubmitOrderSource || (SubmitOrderSource = {}));
var EntityAction;
(function (EntityAction) {
    EntityAction["insert"] = "insert";
    EntityAction["update"] = "update";
    EntityAction["delete"] = "delete";
})(EntityAction || (EntityAction = {}));
var EStatus;
(function (EStatus) {
    EStatus["PENDING"] = "PENDING";
    EStatus["IN_PROGRESS"] = "IN_PROGRESS";
    EStatus["FAILED"] = "FAILED";
    EStatus["SUCCESS"] = "SUCCESS";
})(EStatus || (EStatus = {}));
var EGridBlocks;
(function (EGridBlocks) {
    EGridBlocks["orderBook"] = "orderBook";
    EGridBlocks["tradeHistory"] = "tradeHistory";
    EGridBlocks["depthChart"] = "depthChart";
    EGridBlocks["priceChart"] = "priceChart";
    EGridBlocks["orderForm"] = "orderForm";
    EGridBlocks["orderFormBook"] = "orderFormBook";
    EGridBlocks["tradingView"] = "tradingView";
    EGridBlocks["everChart"] = "everChart";
})(EGridBlocks || (EGridBlocks = {}));
var TradingSessionInfo;
(function (TradingSessionInfo) {
    TradingSessionInfo["NO_TRADING"] = "NO_TRADING";
    TradingSessionInfo["PRE_OPEN"] = "PRE_OPEN";
    TradingSessionInfo["TRADING"] = "TRADING";
})(TradingSessionInfo || (TradingSessionInfo = {}));
var TradingMode;
(function (TradingMode) {
    TradingMode["DEFAULT"] = "DEFAULT";
    TradingMode["DMA"] = "DMA";
    TradingMode["OTC"] = "OTC";
    TradingMode["ALGO"] = "ALGO";
    TradingMode["FUTURES"] = "FUTURES";
})(TradingMode || (TradingMode = {}));
var OrderSchemaType;
(function (OrderSchemaType) {
    OrderSchemaType["DEFAULT"] = "DEFAULT";
    OrderSchemaType["MODIFY"] = "MODIFY";
    OrderSchemaType["DETAILS"] = "DETAILS";
    OrderSchemaType["PRE_OPEN"] = "PRE_OPEN";
    OrderSchemaType["PRE_OPEN_MODIFY"] = "PRE_OPEN_MODIFY";
    OrderSchemaType["LINKED_OUO_VIEW"] = "LINKED_OUO_VIEW";
    OrderSchemaType["LINKED_OSO_VIEW"] = "LINKED_OSO_VIEW";
    OrderSchemaType["LINKED_OSO_OUO_VIEW"] = "LINKED_OSO_OUO_VIEW";
    OrderSchemaType["LINKED_OUO_MAPPING"] = "LINKED_OUO_MAPPING";
    OrderSchemaType["LINKED_OSO_MAPPING"] = "LINKED_OSO_MAPPING";
    OrderSchemaType["LINKED_OSO_OUO_MAPPING"] = "LINKED_OSO_OUO_MAPPING";
})(OrderSchemaType || (OrderSchemaType = {}));
var ApiKeyScope;
(function (ApiKeyScope) {
    ApiKeyScope["read"] = "read";
    ApiKeyScope["trade"] = "trade";
    ApiKeyScope["withdrawal"] = "withdrawal";
    ApiKeyScope["deposit"] = "deposit";
})(ApiKeyScope || (ApiKeyScope = {}));
var DisplayAccountName;
(function (DisplayAccountName) {
    DisplayAccountName["ACCOUNT"] = "ACCOUNT";
    DisplayAccountName["CURRENCY"] = "CURRENCY";
})(DisplayAccountName || (DisplayAccountName = {}));

const cast = (obj, props) => {
    const newObj = cloneDeepWith(obj, (value, key) => {
        if (!props.has(key)) {
            return undefined;
        }
        const transformer = props.get(key);
        if (!transformer) {
            try {
                return toDecimal(value);
            }
            catch (_a) {
                warn('Invalid decimal', value);
                return ZERO;
            }
        }
        else {
            return value && transformer(value);
        }
    });
    return newObj;
};
const propsToMap = (props) => {
    const map = new Map();
    for (const item of props) {
        if (Array.isArray(item)) {
            map.set(item[0], item[1]);
        }
        else {
            map.set(item, void 0);
        }
    }
    return map;
};
const objectPropertiesToDecimal = (props) => {
    const map = propsToMap(props);
    return (obj) => cast(obj, map);
};
const objectArrayPropertiesToDecimal = (props) => {
    const map = propsToMap(props);
    return (obj) => obj.map((i) => cast(i, map));
};
const castArray = (values) => values === null || values === void 0 ? void 0 : values.map(toDecimal);

const castSecurity = objectPropertiesToDecimal([
    'tick_size',
    'multiplier',
    'minimum_quantity',
    'maximum_quantity',
    'default_quantity',
    'quantity_increment',
    // 'buyer_taker_commission_flat',
    // 'buyer_taker_commission_progressive',
    // 'buyer_maker_commission_flat',
    // 'buyer_maker_commission_progressive',
    // 'seller_taker_commission_flat',
    // 'seller_taker_commission_progressive',
    // 'seller_maker_commission_flat',
    // 'seller_maker_commission_progressive',
    'target_price_increment',
    'target_price_maximum',
    'target_price_minimum',
    // 'taker_reserve_multiplier',
]);
const castSecurityV2 = objectPropertiesToDecimal([
    'tick',
    'mul',
    ['qty', castArray],
    ['price', castArray],
]);
const transformSecurityV2toSecurity = ({ adjust_book, base, book_exch, dest, dest_def, display, explain, fract, id, is_rfq, lo_types, m_tif, m_tif_def, mul, name, o_ttl, o_types, pb_acc, pips, price, qty, security_type, show_exch, term, tick, tif, tif_def, time, trade_curr, trade_exch, type, custom2, custom, p_prec, q_prec, calendar_id, po_tif, po_tif_def, }) => {
    return {
        id,
        name,
        adjust_book,
        available_book_exchanges: book_exch,
        available_destinations: dest,
        available_trade_exchanges: trade_exch,
        base_currency: base,
        default_destination: dest_def,
        default_market_time_in_force: m_tif_def,
        default_quantity: qty[0],
        default_time_in_force: tif_def,
        display_method: display,
        execution_explanation: explain,
        is_rfq_allowed: is_rfq,
        linked_order_types: lo_types,
        main_fraction: fract[0],
        market_time_in_forces: m_tif,
        maximum_quantity: qty[3],
        minimum_quantity: qty[1],
        modification_time: time,
        multiplier: mul,
        number_of_fraction_decimals: fract[2],
        order_max_ttl: o_ttl,
        order_types: o_types,
        pips_highlight_end: pips[1],
        pips_highlight_start: pips[0],
        prime_broker_accounts: pb_acc,
        quantity_increment: qty[2],
        security_type,
        show_exchange_id: show_exch,
        sub_fraction: fract[1],
        term_currency: term,
        tick_size: tick,
        time_in_forces: tif,
        trading_currency: trade_curr,
        type,
        custom_data: custom,
        custom_data2: custom2,
        price_precision: p_prec,
        quantity_precision: q_prec,
        target_price_increment: price[1],
        target_price_maximum: price[2],
        target_price_minimum: price[0],
        calendar_id,
        pre_open_time_in_forces: po_tif,
        default_pre_open_time_in_force: po_tif_def,
    };
};

const castSecurityStatistics = objectArrayPropertiesToDecimal([
    'bid',
    'ask',
    'price_24h_change',
    'volume_24h_change',
    'last_trade_price',
    'spread',
    'rawSpread',
    'mid',
    'bidChange',
    'askChange',
    'midChange',
    'spreadChange',
]);

const props$1 = [
    'balance',
    'available_for_trading',
    'available_for_withdrawal',
    'realized_pnl',
    'unrealized_pnl',
    'current_price',
    'enter_average_price',
];
const castAccounts = objectArrayPropertiesToDecimal(props$1);
const castAccountBalances = objectArrayPropertiesToDecimal(props$1);

const castCurrency = objectPropertiesToDecimal([
    'daily_deposit_threshold',
    'daily_withdrawal_threshold',
    'weekly_deposit_threshold',
    'weekly_withdrawal_threshold',
    'monthly_deposit_threshold',
    'monthly_withdrawal_threshold',
    'daily_deposit_limit',
    'daily_withdrawal_limit',
    'weekly_deposit_limit',
    'weekly_withdrawal_limit',
    'monthly_deposit_limit',
    'monthly_withdrawal_limit',
    'withdrawal_commission_progressive',
    'withdrawal_commission_flat',
    'deposit_commission_progressive',
    'deposit_commission_flat',
    'minimal_withdrawal',
    'yearly_deposit_threshold',
    'yearly_deposit_limit',
    'yearly_withdrawal_threshold',
    'yearly_withdrawal_limit',
]);

const castExternalCommission = objectPropertiesToDecimal([
    'maker_commission',
    'taker_commission',
]);

const props = [
    'buyer_taker_commission_flat',
    'buyer_taker_commission_progressive',
    'buyer_maker_commission_flat',
    'buyer_maker_commission_progressive',
    'seller_taker_commission_flat',
    'seller_taker_commission_progressive',
    'seller_maker_commission_flat',
    'seller_maker_commission_progressive',
    'average_balance',
    'total_volume',
];
const castCommissionPlans = objectArrayPropertiesToDecimal(props);
const castCommissionPlan = objectPropertiesToDecimal(props);
const castActiveCommissionPlans = objectPropertiesToDecimal([
    ['current', castCommissionPlan],
    ['next', castCommissionPlan],
    ['next_by_balance', castCommissionPlan],
    ['next_by_volume', castCommissionPlan],
]);

const castSecurityCommissions = objectPropertiesToDecimal([
    'taker_reserve_multiplier',
    [
        'external_commissions',
        (external) => external === null || external === void 0 ? void 0 : external.map(castExternalCommission),
    ],
    ['current_commission_plan', castCommissionPlan],
]);

const castCurrentTradingStatistics = objectPropertiesToDecimal([
    'current_average_balance',
    'current_volume',
    'current_trading_commission',
]);

const castTradingLimits = objectPropertiesToDecimal([
    'daily_volume',
    'daily_volume_limit',
    'monthly_volume',
    'monthly_volume_limit',
    'total_volume',
    'weekly_volume',
    'weekly_volume_limit',
    'yearly_volume',
    'yearly_volume_limit',
]);

const castOrder = objectPropertiesToDecimal([
    'cumulative_quantity',
    'remaining_quantity',
    'average_price',
    'quantity',
    'limit_price',
    'stop_price',
    'last_trade_price',
]);

const castQuote = objectPropertiesToDecimal([
    'ask_price',
    'ask_size',
    'bid_price',
    'bid_size',
]);

export { ApiKeyScope, ChargeFlatCommissionTime, DisplayAccountName, DockPosition, EAccountStatus, EBarType, EChangeSide, ECurrencyType, EDisplayMethod, EGridBlocks, EOperationStatus, EOrderEventType, EOrderStatus, EOrderType, EOrderViewPosition, ESecurityType, EStatus, ETheme, ETimeInForce, ETradingCommissionAccount, ETradingCommissionMethod, ETradingCurrency, ETransactionType, EntityAction, ExecutionExplanation, LinkedOrderType, OrderSchemaType, OrderTable, OrderViewType, PriceTypingType, SecurityType, Side, SubmitOrderSource, TradingMode, TradingSessionInfo, castAccountBalances, castAccounts, castActiveCommissionPlans, castArray, castCommissionPlan, castCommissionPlans, castCurrency, castCurrentTradingStatistics, castExternalCommission, castOrder, castQuote, castSecurity, castSecurityCommissions, castSecurityStatistics, castSecurityV2, castTradingLimits, objectArrayPropertiesToDecimal, objectPropertiesToDecimal, transformSecurityV2toSecurity };
